/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';
import * as moment from 'moment';
import { makeStack, throttleError } from 'utils/basic-utils';
import { fbReporting } from 'src/app/plain-javascript/background-scripts/fb-reporting';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

declare const window: any;

angular.module('ticketspaceApp').directive('fancyLogging', [
	'developerMode',
	function (developerMode) {
		const logger = LoggerServiceFactory.create('fancyLogging');
		function removeElement(ele) {
			ele.removeClass('in');
			// ele.hide(500);
			setTimeout(function () {
				ele.remove();
			}, 600);
		}

		function genElement(message, severity, cb) {
			if (severity === 3) {
				message = 'Debug: ' + message;
			}
			let item = $('<div class="fancy-log">' + message + '</div>');
			//item.hide();

			let hideDelay = 10000;
			switch (severity) {
				case 0:
					item.addClass('error');
					break;
				case 1:
					item.addClass('warning');
					break;
				case 2:
					item.addClass('notice');
					break;
				case 3:
					item.addClass('debug');
					hideDelay = 20000;
					break;
				case 4:
					item.addClass('warning');
					hideDelay = 60000;
					break;
				case 5:
					item.addClass('notice');
					hideDelay = 60000;
					break;
			}

			setTimeout(function () {
				removeElement(item);
				if (cb) {
					cb();
				}
			}, hideDelay);

			item.on('click', function () {
				removeElement(item);
				if (cb) {
					cb();
				}
			});

			return item;
		}

		return {
			restrict: 'EA',
			scope: true,
			compile(element, attrs) {
				//logger.log('element', element);
				element.addClass('fancy-logging-wrapper');

				let errorMap = [];

				let lastAdded: any = {};

				let Logging = (function () {
					function log(message, severity) {
						logger.log('Logging: "' + message + '", ' + moment().format());
						if (lastAdded.message === message && lastAdded.severity === severity) {
							let child = lastAdded.element.find('div');
							if (child.length === 0) {
								child = $('<div>');
								lastAdded.element.append(child);
							}
							lastAdded.count++;
							child.text(lastAdded.count);
							return lastAdded.element;
						}
						let item = genElement(message, severity, function () {
							if (lastAdded.message === message && lastAdded.severity === severity) {
								lastAdded = {};
							}
						});
						element.append(item);
						item.css('opacity');
						//item.show(500);
						item.addClass('in');

						if (severity === 1) {
							fbReporting.reportWarning(message, makeStack(new Error(message)));
						}

						lastAdded = { message, severity, element: item, count: 1 };

						return item;
					}

					function tempItem(message, severity, uniqueId) {
						severity = severity || 2;
						let item = log(message, severity);
						if (uniqueId) {
							item.addClass(uniqueId);
						}

						item.addClass('fancy-logging-temp');
					}

					function close(uniqueId) {
						logger.log('close', uniqueId);
						if (uniqueId) {
							let e = element.find('.' + uniqueId);
							e.hide(300, e.remove);
						} else {
							let e = element.find('.fancy-logging-temp');
							e.hide(300, e.remove);
						}
					}
					let errThrottle = throttleError(function (message, level) {
						log(message, level);
					}, -10000);
					return {
						log,
						error(message) {
							errThrottle(message, 0);
						},
						warning(message) {
							log(message, 1);
						},
						longWarning(message) {
							log(message, 4);
						},
						notice(message) {
							log(message, 2);
						},
						longNotice(message) {
							log(message, 5);
						},
						debug(message) {
							if (developerMode) {
								errThrottle(message, 3);
							}
						},
						tempItem,
						close,
					};
				})();
				window.Logging = Logging;
			},
		};
	},
]);
